<!-- filepath: c:\Users\adilr\Desktop\Megahissotto-F\MegaHissotto-F-master\src\pages\Recrutment.vue -->
<template>
  <main class="bg-blue-50 min-h-screen py-12 px-4 sm:px-6 lg:px-8 mt-16">
    <div class="max-w-7xl mx-auto">
      <h1 class="text-4xl font-bold text-blue-800 text-center mb-12">
        {{ t('Recrut.title') }}
      </h1>
      <!-- ...existing code... -->
        <!-- Simple Menu for Filtering -->
        <div class="mb-8 flex justify-center space-x-4">
        <button @click="currentView = 'jobs'" :class="{'bg-blue-600 text-white': currentView === 'jobs', 'bg-white text-blue-600': currentView !== 'jobs'}" class="px-4 py-2 rounded-md transition duration-300">
          {{ $t('Recrut.Nos_besoins') }}
        </button>
        <button @click="switchToGeneralForm" :class="{'bg-blue-600 text-white': currentView === 'generalForm', 'bg-white text-blue-600': currentView !== 'generalForm'}" class="px-4 py-2 rounded-md transition duration-300">
          {{ $t('Recrut.Candidature_spontanee') }}
        </button>
      </div>

      <!-- Job Listings -->
      <section v-if="currentView === 'jobs'" class="mb-16">
        <h2 class="text-2xl font-semibold text-blue-700 mb-6">{{ $t('Recrut.Nos_besoins') }}</h2>
        <div v-if="loading" class="flex justify-center items-center min-h-screen">
          <div class="loading">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div v-else-if="error" class="text-center text-red-500">{{ error.message }}</div>
        <div v-else class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div v-for="job in jobs" :key="job.id" class="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition duration-300">
            <h3 class="text-xl font-semibold text-blue-700 mb-2">{{ job.name }}</h3>
            <p class="text-gray-600 mb-4">{{ job.description }}</p>
            <button @click="selectJob(job)" class="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition duration-300 w-full">
              {{ $t('Recrut.Postuler') }}
            </button>
          </div>
        </div>
      </section>

      <!-- Application Form for Specific Job -->
      <section v-if="selectedJob" class="bg-white rounded-lg shadow-md p-8 max-w-2xl mx-auto">
        <h2 class="text-2xl font-bold text-blue-800 mb-6">{{ $t('Recrut.Postuler') }} : {{ selectedJob.name }}</h2>
        <form @submit.prevent="submitApplication" class="space-y-4">
          <div>
            <label for="name" class="block text-sm font-medium text-gray-700">{{ $t('Recrut.Nom_complet') }}</label>
            <input type="text" id="name" v-model="application.name" required class="mt-1 block w-full rounded-md border-gray-300 shadow-sm" @focus="checkToken">
          </div>
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700">{{ $t('Recrut.Email') }}</label>
            <input type="email" id="email" v-model="application.email" required class="mt-1 block w-full rounded-md border-gray-300 shadow-sm" @focus="checkToken">
          </div>
          <div>
            <label for="phone" class="block text-sm font-medium text-gray-700">{{ $t('Recrut.Tel') }}</label>
            <input type="tel" id="phone" v-model="application.phone" required class="mt-1 block w-full rounded-md border-gray-300 shadow-sm" @focus="checkToken">
          </div>
          <div>
            <label for="resume" class="block text-sm font-medium text-gray-700">{{ $t('Recrut.CV') }}</label>
            <input type="file" id="resume" accept=".pdf" @change="handleFileUpload" required class="mt-1 block w-full" @focus="checkToken">
          </div>
          <div class="flex justify-end">
            <button type="submit" class="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition duration-300" @click="checkToken">{{ $t('Recrut.Envoyer_candidature') }}</button>
          </div>
        </form>
      </section>

      <!-- General Application Form -->
      <section v-if="currentView === 'generalForm'" class="bg-white rounded-lg shadow-md p-8 max-w-2xl mx-auto">
        <h2 class="text-2xl font-bold text-blue-800 mb-6">{{ $t('Recrut.Candidature_spontanee') }}</h2>
        <form @submit.prevent="submitGeneralApplication" class="space-y-4">
          <div>
            <label for="generalName" class="block text-sm font-medium text-gray-700">{{ $t('Recrut.Nom_complet') }}</label>
            <input type="text" id="generalName" v-model="generalApplication.name" required class="mt-1 block w-full rounded-md border-gray-300 shadow-sm" @focus="checkToken">
          </div>
          <div>
            <label for="generalEmail" class="block text-sm font-medium text-gray-700">{{ $t('Recrut.Email') }}</label>
            <input type="email" id="generalEmail" v-model="generalApplication.email" required class="mt-1 block w-full rounded-md border-gray-300 shadow-sm" @focus="checkToken">
          </div>
          <div>
            <label for="generalPhone" class="block text-sm font-medium text-gray-700">{{ $t('Recrut.Tel') }}</label>
            <input type="tel" id="generalPhone" v-model="generalApplication.phone" required class="mt-1 block w-full rounded-md border-gray-300 shadow-sm" @focus="checkToken">
          </div>
          <div>
            <label for="generalResume" class="block text-sm font-medium text-gray-700">{{ $t('Recrut.CV') }}</label>
            <input type="file" id="generalResume" accept=".pdf" @change="handleGeneralFileUpload" required class="mt-1 block w-full" @focus="checkToken">
          </div>
          <div class="flex justify-end">
            <button type="submit" class="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition duration-300" @click="checkToken">{{ $t('Recrut.Envoyer_candidature') }}</button>
          </div>
        </form>
      </section>

      <!-- Modal -->
      <div v-if="showModal" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div class="bg-white p-8 rounded-lg shadow-lg">
          <h3 class="text-xl font-bold mb-4">Create an Account</h3>
          <p class="mb-4">You need to create an account to contact us.</p>
          <router-link to="/Auth" class="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-medium py-3 px-6 rounded-lg text-center transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-md">Create Account</router-link>
          <button @click="closeModal" class="mt-4 text-gray-600 hover:text-gray-800 font-medium py-2 px-4 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">Close</button>
        </div>
      </div>

      <!-- HR Email Information -->
      <div class="mt-12 text-center">
        <p class="text-gray-600">{{ $t('Recrut.Contact_rh') }}</p>
        <a href="mailto:personnel@megahissotto.com" class="text-blue-600 hover:underline">personnel@megahissotto.com</a>
      </div>
    </div>
  </main>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDataStore } from '@/stores/mainStore';
import { useHead } from '@vueuse/head';

useHead({
  title: 'Recrutement | Mega Hissotto – Rejoignez notre équipe en Algérie',
  meta: [
      { name: 'description', content: "Rejoignez Mega Hissotto, leader en climatisation industrielle et froid industriel en Algérie. Consultez nos offres d'emploi et envoyez votre candidature." },
    { name: 'keywords', content: 'recrutement climatisation Algérie, emploi froid industriel, offre emploi HVAC, Mega Hissotto carrière' },
    { property: 'og:title', content: 'Recrutement | Mega Hissotto' },
    { property: 'og:url', content: 'https://www.mega-hissotto.com/Recrutment' },
  ],
  link: [{ rel: 'canonical', href: 'https://www.mega-hissotto.com/Recrutment' }]
});

const { t } = useI18n();
const dataStore = useDataStore();

const currentView = ref('jobs');
const selectedJob = ref(null);
const application = ref({
  name: '',
  email: '',
  phone: '',
  resume: null
});

const generalApplication = ref({
  name: '',
  email: '',
  phone: '',
  resume: null,
  message: ''
});

const jobs = ref([]);
const showModal = ref(false);
const token = localStorage.getItem('token');

onMounted(async () => {
  dataStore.loading = true;
  try {
    await dataStore.fetchData();
    jobs.value = dataStore.data.jobsNeeds;
  } catch (err) {
    dataStore.error = err;
  } finally {
    dataStore.loading = false;
  }
});

const selectJob = (job) => {
  selectedJob.value = job;
  currentView.value = 'jobs';
  setTimeout(() => {
    const formElement = document.querySelector('form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  }, 100);
};

const handleFileUpload = (event) => {
  application.value.resume = event.target.files[0];
};

const handleGeneralFileUpload = (event) => {
  generalApplication.value.resume = event.target.files[0];
};

const checkToken = () => {
  if (!token) {
    showModal.value = true;
  }
};

const closeModal = () => {
  showModal.value = false;
};

const submitApplication = async () => {
  if (!token) {
    showModal.value = true;
    return;
  }

  const formData = new FormData();
  formData.append('type', 'besoin');
  formData.append('id_offer', selectedJob.value.id);
  formData.append('full_name', application.value.name);
  formData.append('email', application.value.email);
  formData.append('phone', application.value.phone);
  formData.append('resume', application.value.resume);

  try {
    const response = await dataStore.submitJobApplication(formData);
    alert('Votre candidature a été soumise avec succès !');
    application.value = { name: '', email: '', phone: '', resume: null };
    selectedJob.value = null;
  } catch (error) {
    alert('Erreur lors de la soumission de la candidature.');
  }
};

const submitGeneralApplication = async () => {
  if (!token) {
    showModal.value = true;
    return;
  }

  const formData = new FormData();
  formData.append('type', 'spontane');
  formData.append('full_name', generalApplication.value.name);
  formData.append('email', generalApplication.value.email);
  formData.append('phone', generalApplication.value.phone);
  formData.append('resume', generalApplication.value.resume);
  formData.append('message', generalApplication.value.message);

  try {
    const response = await dataStore.submitGeneralApplication(formData);
    alert('Votre candidature spontanée a été soumise avec succès !');
    generalApplication.value = { name: '', email: '', phone: '', resume: null, message: '' };
  } catch (error) {
    alert('Erreur lors de la soumission de la candidature spontanée.');
  }
};

const switchToGeneralForm = () => {
  currentView.value = 'generalForm';
  selectedJob.value = null;
};
</script>

<style scoped>
.project-card {
  animation: fadeInUp 0.5s ease-out forwards;
  opacity: 0;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in {
  animation: fadeIn 1s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Loading Spinner */
.loading {
  --speed-of-animation: 0.9s;
  --gap: 6px;
  --first-color: #4c86f9;
  --second-color: #49a84c;
  --third-color: #f6bb02;
  --fourth-color: #f6bb02;
  --fifth-color: #2196f3;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  gap: 6px;
  height: 100px;
}

.loading span {
  width: 4px;
  height: 50px;
  background: var(--first-color);
  animation: scale var(--speed-of-animation) ease-in-out infinite;
}

.loading span:nth-child(2) {
  background: var(--second-color);
  animation-delay: -0.8s;
}

.loading span:nth-child(3) {
  background: var(--third-color);
  animation-delay: -0.7s;
}

.loading span:nth-child(4) {
  background: var(--fourth-color);
  animation-delay: -0.6s;
}

.loading span:nth-child(5) {
  background: var(--fifth-color);
  animation-delay: -0.5s;
}

@keyframes scale {
  0%, 40%, 100% {
    transform: scaleY(0.05);
  }

  20% {
    transform: scaleY(1);
  }
}

/* Loading Animation */
body.loading::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: loadingFadeOut 0.5s ease-out 1s forwards;
}

body.loading::after {
  content: 'Loading...';
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 24px;
  z-index: 10000;
  animation: loadingFadeOut 0.5s ease-out 1s forwards;
}

@keyframes loadingFadeOut {
  to {
    opacity: 0;
    visibility: hidden;
  }
}
</style>